/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Programmatic_Seo_Index_Desc5Inputs */

const en_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemaps split and submitted, internal links keep crawlers moving.`)
};

const ar_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`خرائط الموقع تقسم وتقدم، والروابط الداخلية تبقي الزواحف متحركة.`)
};

const bn_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`সাইটম্যাপ ভাগ করে জমা দেওয়া, অভ্যন্তরীণ লিঙ্ক ক্রলারদের চালায়।`)
};

const de_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemaps aufgeteilt und eingereicht, interne Links halten Crawler in Bewegung.`)
};

const es_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemaps divididos y enviados, enlaces internos que mantienen a los rastreadores en marcha.`)
};

const fr_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemaps découpés et soumis, liens internes qui gardent les robots en mouvement.`)
};

const pt_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitemaps divididos e submetidos, ligações internas que mantêm os crawlers em marcha.`)
};

const zh_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`站点地图拆分提交，内链带着爬虫一直走。`)
};

const tr_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Site haritaları bölünüp gönderilir, iç bağlantılar tarayıcıları gezdirir.`)
};

const ru_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Карты сайта разбиты и отправлены, внутренние ссылки ведут краулеров дальше.`)
};

const pl_svc_programmatic_seo_index_desc5 = /** @type {(inputs: Svc_Programmatic_Seo_Index_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mapy strony pocięte i zgłoszone, linki wewnętrzne prowadzą crawlery dalej.`)
};

/**
* | output |
* | --- |
* | "Sitemaps split and submitted, internal links keep crawlers moving." |
*
* @param {Svc_Programmatic_Seo_Index_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_programmatic_seo_index_desc5 = /** @type {((inputs?: Svc_Programmatic_Seo_Index_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Programmatic_Seo_Index_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "bn") return bn_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "de") return de_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "es") return es_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "fr") return fr_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "pt") return pt_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "zh") return zh_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "tr") return tr_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "ru") return ru_svc_programmatic_seo_index_desc5(inputs)
	if (locale === "pl") return pl_svc_programmatic_seo_index_desc5(inputs)
	return en_svc_programmatic_seo_index_desc5(inputs)
});
export { svc_programmatic_seo_index_desc5 as "svc_programmatic-seo_INDEX_desc" }